import { createAction } from 'redux-actions';
import { MERGE_SUPPLEMENTAL_OBJECTS } from '../constants/actionTypes';
export const mergeSupplementalObjects = createAction(MERGE_SUPPLEMENTAL_OBJECTS);